var _templateObject;

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

import React, { useState, useEffect } from 'react';
import i18n from '@pureartisan/simple-i18n';
import clsx from 'clsx';
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import { max, min } from 'd3-array';
import useStore from './../store';
import { formatIndicatorValue, getRoundedValue } from './../utils';
import styled from 'styled-components';

var roundValue = function roundValue(num, dec) {
  return Math.round(num * Math.pow(10, dec)) / Math.pow(10, dec);
};

var CustomTooltip = function CustomTooltip(_ref) {
  var active = _ref.active,
      payload = _ref.payload,
      label = _ref.label; // console.log('CustomTooltip, ', active, payload, label)

  if (!active || !payload || !payload.length) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "trend-chart-tooltip"
  }, /*#__PURE__*/React.createElement("span", {
    className: clsx('label')
  }, label), ': ', /*#__PURE__*/React.createElement("span", {
    className: clsx('value')
  }, payload[0].payload.display));
}; // bring chart forward in z direction


var ChartContainer = styled(ResponsiveContainer)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n  z-index: 501;\n  left: -5px;\n"])));

var TrendChart = function TrendChart(_ref2) {
  var data = _ref2.data,
      config = _ref2.config,
      layerIndex = _ref2.layerIndex;
  var currency = config.currency;
  var percent = config.percent;
  var decimals = config.decimals;
  var id = config.id;
  var dataSet = data.map(function (el) {
    return {
      name: Number(el.year),
      // Flip the value calc if high is not good.
      value: roundValue(Number(el[id]), percent ? decimals + 2 : decimals),
      raw: Number(el[id]),
      display: getRoundedValue(Number(el[id]), decimals, false, currency, percent)
    };
  }).sort(function (a, b) {
    return a.year - b.year;
  });
  return /*#__PURE__*/React.createElement(ChartContainer, {
    width: "82%",
    height: 32
  }, /*#__PURE__*/React.createElement(AreaChart, {
    data: dataSet
  }, /*#__PURE__*/React.createElement(XAxis, {
    dataKey: "name",
    tick: false,
    height: 1
  }), /*#__PURE__*/React.createElement(YAxis, {
    dataKey: "value",
    domain: ['dataMin', 'dataMax'] // domain={[min, max]}
    ,
    tick: false,
    reversed: false,
    width: 1
  }), /*#__PURE__*/React.createElement(Tooltip, {
    allowEscapeViewBox: {
      x: true,
      y: true
    },
    content: /*#__PURE__*/React.createElement(CustomTooltip, null),
    animationBegin: 1200,
    isAnimationActive: false,
    animationEasing: 'linear',
    itemStyle: {
      backgroundColor: 'white'
    },
    position: {
      x: 200,
      y: 36
    },
    wrapperStyle: {
      fontSize: 12,
      fontFamily: 'Knockout 49 A',
      color: 'white',
      backgroundColor: '#2c390b',
      padding: '1rem',
      borderRadius: '4px',
      left: '-50%'
    }
  }), /*#__PURE__*/React.createElement(Area, {
    type: "monotone",
    dataKey: "value",
    stroke: "#626B77",
    fill: "#EAEFF4",
    dot: false,
    reversed: false
  })));
};

var IndicatorTrend = function IndicatorTrend(_ref3) {
  var data = _ref3.data,
      config = _ref3.config,
      props = _objectWithoutPropertiesLoose(_ref3, ["data", "config"]);

  var activeLayers = useStore(function (state) {
    return state.activeLayers;
  });
  var years = data.map(function (el) {
    return Number(el.year);
  });
  var yearMax = Math.max.apply(Math, years);
  var yearMin = Math.min.apply(Math, years);
  var yearDiff = yearMax - yearMin + 1;
  var values = data.map(function (d) {
    return roundValue(Number(d[config.id]), config.percent ? config.decimals + 2 : config.decimals);
  });
  var highIsGood = Number(config.highisgood);
  var current = values[values.length - 1];
  var diff = current - values[0];
  var diffLabel = diff > 0 && highIsGood ? 'increased' : 'decreased';
  var diffValue = formatIndicatorValue(Math.abs(diff), config);
  var roboKey = diff === 0 ? "TREND_ROBO_NO_DIFF" : "TREND_ROBO_DIFF";
  var context = {
    diff: diff,
    diffLabel: diffLabel,
    diffValue: diffValue,
    years: [yearMin, yearMax].join(' - ')
  };
  var roboText = i18n.translate(roboKey, context);
  return /*#__PURE__*/React.createElement("div", props, /*#__PURE__*/React.createElement("p", {
    className: "gotham12 mb-3",
    dangerouslySetInnerHTML: {
      __html: roboText
    }
  }), /*#__PURE__*/React.createElement(TrendChart, {
    data: data,
    config: config,
    layerIndex: activeLayers.indexOf(1)
  }));
};

export default IndicatorTrend;